const ACTIONS = {
    JOIN: 'join',
    JOINED: 'joined',
    DISCONNECTED: 'disconnected',
    LEAVE: 'leave',
    CODE_CHANGE: 'code-change',
    SYNC_CODE: 'sync-code',
}
module.exports = ACTIONS;